/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_TestInputs */

const cs_action_test = /** @type {(inputs: Action_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otestovat`)
};

const en_action_test = /** @type {(inputs: Action_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test`)
};

/**
* | output |
* | --- |
* | "Test" |
*
* @param {Action_TestInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_test = /** @type {((inputs?: Action_TestInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_TestInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_test(inputs)
	return cs_action_test(inputs)
});